import type {
  FindCardsDashboardTypes,
  FindTEFsType,
  FindCRTSGraphicsTypes,
  TerminaisVersaoProps,
  CompanyByNameTypes,
  FindClientsByTEFTypes,
  ResponseFindClientsByTEFTypes,
  FindClientsByCRTParms,
} from "types/DashbordTypes";
import baseUrl from "../services/api";

export async function FindCardsDashboard(): Promise<FindCardsDashboardTypes> {
  const response = await baseUrl.get(`/dashboard/informacoes`);

  return response.data;
}

export async function FindTermalsVersions(
  parms: TerminaisVersaoProps
): Promise<PaginateProps<CompanyByNameTypes>> {
  const response = await baseUrl.get(`/dashboard/terminaisVersao`, {
    params: parms,
  });

  return response.data;
}

export async function FindClientsListDashboard(days: number) {
  const response = await baseUrl.get(`/dashboard/dashEmpresas`, {
    params: {
      days: days,
    },
  });

  return response.data;
}

export async function FindVersionsModule(days: number, module: string) {
  const response = await baseUrl.get(`/dashboard/versoesPerido`, {
    params: {
      days,
      module,
    },
  });

  return response.data;
}

export async function FindTEFs(days: number): Promise<FindTEFsType[]> {
  const response = await baseUrl.get(`/dashboard/tefs`, {
    params: {
      days,
    },
  });

  return response.data;
}

export async function FindClientsByTEF(
  parms: FindClientsByTEFTypes
): Promise<PaginateProps<ResponseFindClientsByTEFTypes[]>> {
  const response = await baseUrl.get(`/dashboard/terminaisTef`, {
    params: parms,
  });

  return response.data;
}

export async function FindCRTSGraphics(
  days: number
): Promise<FindCRTSGraphicsTypes[]> {
  const response = await baseUrl.get(`/dashboard/CRTGraphic`, {
    params: {
      days,
    },
  });

  return response.data;
}

export async function FindClientsByCRTFunction(parms: FindClientsByCRTParms) {
  const response = await baseUrl.get(`/dashboard/crtsInfos`, {
    params: parms,
  });

  return response.data;
}
